import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { useEffect } from 'react';
import gpsIcon from '../../Assets/images/paymentlogo/gps.png';
import gpsIconNew from '../../Assets/images/paymentlogo/gpsnew.png';

// const clinicPosition = [51.505, -0.09];
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

export default function ClinicMap({ widthAndheight,passData }) {
    // console.log('ClinicMap:::', passData);
    const { cood } = passData || {};
    const coordinates = cood.map(item => item.data);
    function FitBounds({ coordinates }) {
        const map = useMap();

        useEffect(() => {
            if (coordinates.length > 0) {
                const bounds = L.latLngBounds(coordinates);
                map.fitBounds(bounds, { padding: [10, 10] });
            }
        }, [coordinates, map]);

        return null;
    }
    return (
        <MapContainer
            center={[0, 0]}
            zoom={13}
            // scrollWheelZoom={false}
            zoomControl={false}
            style={{ width: 400, height: 300, borderRadius: "2px", backgroundColor: '#00838540',...widthAndheight }}
        >
            <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            // attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            />
            {cood && cood.length && cood.map((item, index) => {
                // console.log('item:::', item.data);
                return <Marker position={item.data} key={index} icon={L.icon({
                    iconUrl: `${gpsIconNew}` ?? require('leaflet/dist/images/marker-icon.png'),
                   iconSize: [22, 30],          // icon is 22x30
                    iconAnchor: [11, 30],        // point bottom-center of the icon to the lat/lng
                    popupAnchor: [0, -30],       // show popup above the icon
                    shadowSize: [22, 30]
                })} >
                    <Popup  >{item.name ?? ''}</Popup>
                    {/* <Tooltip permanent direction="bottom" offset={[0, -10]}>
                        {item.name ?? ''}
                    </Tooltip> */}
                </Marker>
            })}
            <FitBounds coordinates={coordinates} />
        </MapContainer>
    );
}
